// @flow

import * as React from 'react';
import { TopBarContentProviderContextPropType } from './TopBarContentProvider';
import type { TopBarContentProviderContext } from './TopBarContentProvider';

export default class TopBarContent extends React.Component<*> {
  context: TopBarContentProviderContext;
  static contextTypes = {
    ui_tbc: TopBarContentProviderContextPropType,
  };

  render() {
    if (this.context.ui_tbc) {
      return this.props.children(this.context.ui_tbc);
    } else {
      return this.props.children({});
    }
  }
}
